import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "green-room-container"
};
const _hoisted_2 = {
  class: "content-header"
};
const _hoisted_3 = {
  key: 0,
  class: "content-body"
};
const _hoisted_4 = {
  class: "selected-props-container"
};
const _hoisted_5 = {
  class: "review-status-container"
};
const _hoisted_6 = {
  key: 0,
  class: "status-text pending"
};
const _hoisted_7 = {
  key: 1,
  class: "status-text under-review"
};
const _hoisted_8 = {
  key: 2,
  class: "status-text reject"
};
const _hoisted_9 = {
  key: 3,
  class: "status-text accept"
};
const _hoisted_10 = {
  class: "role-load-container"
};
const _hoisted_11 = {
  style: {
    "margin-right": "0.5rem"
  }
};
const _hoisted_12 = {
  key: 1,
  class: "prepared-props-list"
};
const _hoisted_13 = {
  class: "role-pocket-container"
};
const _hoisted_14 = {
  key: 1,
  class: "content-body"
};
const _hoisted_15 = {
  key: 1,
  class: "prepared-props-grid-list"
};
import { onMounted, computed, ref } from 'vue';
import { ElMessage, ElProgress, ElRow } from 'element-plus';
import { request } from '@/manager/net_manager';
import store from '@/store';
import { pageStyle } from "@/theme/sliderStyle";
import { gradientPercentageColors } from "@/tools/utils"; // import PropsCard from "@/components/Props/PropsCard.vue";

import GreenRoomPocket from "@/components/Stage/GreenRoomPocket.vue";
import PreparedPropCard from "@/components/Stage/PreparedPropCard.vue";
import MaskerLayer from "@/components/Basic/MaskerLayer.vue";
import PocketPropsCard from "@/components/Props/PocketPropsCard.vue"; // refs

export default {
  __name: 'GreenRoomPage',

  setup(__props) {
    const preparedProps = ref({});
    const inspectionStatus = ref(-1);
    const roleProp = ref(null); // computed

    const stage = computed(() => store.state.stage ?? null);
    const ticketRole = computed(() => store.state.stage_role ?? null);
    const roleLoadValue = computed(() => {
      if (!ticketRole.value) return 0.0;
      return ticketRole.value.load_value ?? 0.0;
    });
    const preparedWeight = computed(() => {
      return Object.values(preparedProps.value).reduce((sum, item) => {
        return sum + item.weight ?? 0.0;
      }, 0.0);
    });
    const loadPercentage = computed(() => {
      if (roleLoadValue.value === 0.0) return 0.0;
      const percentage = preparedWeight.value / roleLoadValue.value * 100;
      return Math.min(percentage, 100.0);
    }); // functions

    const getData = () => {
      const parameters = {
        'stage_id': stage.value.stage_id,
        'role_id': ticketRole.value.id,
        'is_precis': true
      };
      request('stage/props_review/get/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          if (Object.keys(response.data).length === 0) {
            inspectionStatus.value = -1;
          } else {
            inspectionStatus.value = response.data.status;
            preparedProps.value = response.data.props.reduce((dict, item) => {
              dict[item.id] = item;
              return dict;
            }, {});
          }
        }
      });
    };

    const clickPreparedProp = propData => {
      if (Object.keys(preparedProps.value).includes(propData.id.toString())) {
        delete preparedProps.value[propData.id];
      }
    };

    const clickUnpreparedProp = propData => {
      if (Object.keys(preparedProps.value).includes(propData.id.toString())) {
        delete preparedProps.value[propData.id.toString()];
      } else {
        if (propData.weight + preparedWeight.value >= roleLoadValue.value) {
          ElMessage.warning({
            message: '角色承载已达上限',
            duration: 1500
          });
          return;
        }

        preparedProps.value[propData.id.toString()] = propData;
      }
    };

    const loadGigBox = () => {
      request('role/gig_box/get/', {
        'role_id': ticketRole.value.id
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          if (Object.keys(response.data).length === 0) {
            ElMessage.warning({
              message: '未读取到前次配置',
              duration: 1500
            });
            return;
          }

          preparedProps.value = response.data.props.reduce((dict, item) => {
            dict[item.id] = item;
            return dict;
          }, {});
        }
      });
    };

    const submitProps = () => {
      const parameters = {
        'stage_id': stage.value.stage_id,
        'role_id': ticketRole.value.id,
        'prop_ids': Object.keys(preparedProps.value)
      };
      request('stage/props_review/create/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          if (inspectionStatus.value === -1 || inspectionStatus.value === 1) {
            ElMessage.success({
              message: '物品配置已提交',
              duration: 1500
            });
          } else {
            ElMessage.success({
              message: '更新配置已提交',
              duration: 1500
            });
          }

          inspectionStatus.value = response.data.status;
        }
      });
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", {
        id: "page-container",
        style: _normalizeStyle(_unref(pageStyle))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("text", _hoisted_2, _toDisplayString(`${stage.value.stage_name} / 候场室`), 1), _cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), inspectionStatus.value !== 2 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [inspectionStatus.value === -1 ? (_openBlock(), _createElementBlock("text", _hoisted_6, "尚未决定")) : _createCommentVNode("", true), inspectionStatus.value === 0 ? (_openBlock(), _createElementBlock("text", _hoisted_7, "等待许可")) : _createCommentVNode("", true), inspectionStatus.value === 1 ? (_openBlock(), _createElementBlock("text", _hoisted_8, "需要调整")) : _createCommentVNode("", true), inspectionStatus.value === 2 ? (_openBlock(), _createElementBlock("text", _hoisted_9, "已获许可")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, [_cache[1] || (_cache[1] = _createElementVNode("text", {
        class: "title"
      }, "角色承载", -1)), _createVNode(_unref(ElProgress), {
        color: _unref(gradientPercentageColors),
        percentage: loadPercentage.value,
        "text-inside": true,
        "stroke-width": 16,
        class: "attribute-item-progress load_progress"
      }, {
        default: _withCtx(() => [_createElementVNode("text", _hoisted_11, _toDisplayString(`${preparedWeight.value.toFixed(1)} / ${roleLoadValue.value}`), 1)]),
        _: 1
      }, 8, ["color", "percentage"])]), _createVNode(_unref(ElRow), {
        class: "operate-container"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: loadGigBox
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 加载前次配置 ", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: submitProps
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(inspectionStatus.value === -1 ? '提交配置' : '提交配置更新'), 1)]),
          _: 1
        })]),
        _: 1
      }), Object.keys(preparedProps.value).length === 0 ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        class: "empty-data-tips"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("text", null, "未选择携带道具", -1)]))]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(preparedProps.value).reverse(), ([key, value]) => {
        return _openBlock(), _createBlock(PreparedPropCard, {
          key: key,
          data: value,
          status: inspectionStatus.value,
          onClick: $event => clickPreparedProp(value)
        }, null, 8, ["data", "status", "onClick"]);
      }), 128))]))]), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "v-divider"
      }, null, -1)), _createElementVNode("div", _hoisted_13, [_createVNode(GreenRoomPocket, {
        "role-id": ticketRole.value.id,
        "prepared-props": preparedProps.value,
        onSelectedProp: clickUnpreparedProp
      }, null, 8, ["role-id", "prepared-props"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [Object.keys(preparedProps.value).length === 0 ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        class: "empty-data-tips"
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("text", null, "未选择携带道具", -1)]))]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(preparedProps.value).reverse(), ([key, value]) => {
        return _openBlock(), _createBlock(PreparedPropCard, {
          key: key,
          data: value,
          status: inspectionStatus.value,
          onClick: $event => roleProp.value = value
        }, null, 8, ["data", "status", "onClick"]);
      }), 128))]))]))]), roleProp.value !== null ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 0,
        onClose: _cache[0] || (_cache[0] = $event => roleProp.value = null)
      }, {
        default: _withCtx(() => [_createVNode(PocketPropsCard, {
          "prop-id": roleProp.value?.id,
          "operation-enable": false
        }, null, 8, ["prop-id"])]),
        _: 1
      })) : _createCommentVNode("", true)], 4);
    };
  }

};